import { render, staticRenderFns } from "./BidSheet.vue?vue&type=template&id=00b0f23f&scoped=true&"
import script from "./BidSheet.vue?vue&type=script&lang=js&"
export * from "./BidSheet.vue?vue&type=script&lang=js&"
import style0 from "./BidSheet.vue?vue&type=style&index=0&id=00b0f23f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b0f23f",
  null
  
)

export default component.exports